var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommentActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5619 39.1397L19.2582 40.2731L18.1716 44.3284L25.2638 42.4281L25.7661 42.2935L26.2702 42.4206C27.7618 42.7965 29.3497 43 31 43C40.1935 43 47 36.8538 47 30C47 23.1462 40.1935 17 31 17C21.8065 17 15 23.1462 15 30C15 33.114 16.357 36.023 18.7207 38.3216L19.5619 39.1397ZM17.3263 39.7554C14.6293 37.1327 13 33.7249 13 30C13 21.7157 21.0589 15 31 15C40.9411 15 49 21.7157 49 30C49 38.2843 40.9411 45 31 45C29.1852 45 27.4332 44.7762 25.7815 44.3599L17.0162 46.7086C16.2726 46.9078 15.5922 46.2274 15.7914 45.4838L17.3263 39.7554Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommentActive);
export default __webpack_public_path__ + "static/media/comment-active.33f823ba3875a30c423d61b6c8c8bbc2.svg";
export { ForwardRef as ReactComponent };